import React from 'react';
import { Link } from 'react-router-dom';
import { PHONE_DISPLAY, PHONE_HREF } from './assets';

const STEPS = [
  ['Send your request.', 'Fill out the form or give us a call. Tell us about your space and the service you need.'],
  ['Talk with a Gleam Guru.', 'A team member reaches out to discuss the details, your needs, and scheduling.'],
  ['Confirm your clean.', 'We finalize the scope, pricing, and schedule with you before your service is booked.'],
];

export const HowBookingWorks = () => (
  <section className="booking" id="how-booking-works" aria-labelledby="booking-heading" data-testid="how-booking-works-section">
    <div className="booking-inner">
      <div className="booking-top">
        <h2 id="booking-heading"><span>HOW</span><br />BOOKING WORKS.</h2>
        <span className="booking-count">01 — 03</span>
      </div>
      <ol className="booking-steps">
        {STEPS.map(([title, body], i) => (
          <li key={title}>
            <span className="booking-num" aria-hidden="true">{`0${i + 1}`}</span>
            <div>
              <h3>{title}</h3>
              <p>{body}</p>
            </div>
          </li>
        ))}
      </ol>
      <div className="booking-bottom">
        <Link className="booking-cta" to="/#quote-form" data-testid="booking-cta">TALK WITH A GLEAM GURU <span aria-hidden="true">↗</span></Link>
        <a className="booking-phone" href={PHONE_HREF} data-testid="booking-phone">Prefer to call? {PHONE_DISPLAY}</a>
      </div>
    </div>
  </section>
);
